// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetStatistics200ResponseStudiesHealth } from './get-statistics200-response-studies-health';
import {
    GetStatistics200ResponseStudiesHealthFromJSON,
    GetStatistics200ResponseStudiesHealthFromJSONTyped,
    GetStatistics200ResponseStudiesHealthToJSON,
    GetStatistics200ResponseStudiesHealthToJSONTyped,
} from './get-statistics200-response-studies-health';

/**
 * 
 * @export
 * @interface GetStatistics200ResponseStudies
 */
export interface GetStatistics200ResponseStudies {
    /**
     * Studies with ACTIVE status
     * @type {number}
     * @memberof GetStatistics200ResponseStudies
     */
    active: number;
    /**
     * 
     * @type {GetStatistics200ResponseStudiesHealth}
     * @memberof GetStatistics200ResponseStudies
     */
    health: GetStatistics200ResponseStudiesHealth;
    /**
     * Studies with at least one DRAFT DTA
     * @type {number}
     * @memberof GetStatistics200ResponseStudies
     */
    needsAttention: number;
    /**
     * Total studies assigned to the user
     * @type {number}
     * @memberof GetStatistics200ResponseStudies
     */
    total: number;
}

/**
 * Check if a given object implements the GetStatistics200ResponseStudies interface.
 */
export function instanceOfGetStatistics200ResponseStudies(value: object): value is GetStatistics200ResponseStudies {
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('health' in value) || value['health'] === undefined) return false;
    if (!('needsAttention' in value) || value['needsAttention'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetStatistics200ResponseStudiesFromJSON(json: any): GetStatistics200ResponseStudies {
    return GetStatistics200ResponseStudiesFromJSONTyped(json, false);
}

export function GetStatistics200ResponseStudiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatistics200ResponseStudies {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'],
        'health': GetStatistics200ResponseStudiesHealthFromJSON(json['health']),
        'needsAttention': json['needsAttention'],
        'total': json['total'],
    };
}

export function GetStatistics200ResponseStudiesToJSON(json: any): GetStatistics200ResponseStudies {
    return GetStatistics200ResponseStudiesToJSONTyped(json, false);
}

export function GetStatistics200ResponseStudiesToJSONTyped(value?: GetStatistics200ResponseStudies | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'health': GetStatistics200ResponseStudiesHealthToJSON(value['health']),
        'needsAttention': value['needsAttention'],
        'total': value['total'],
    };
}
